import { render, staticRenderFns } from "./CardsService.vue?vue&type=template&id=c6c24f0e&"
import script from "./CardsService.vue?vue&type=script&lang=js&"
export * from "./CardsService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports